import { render, staticRenderFns } from "./couponHistList.vue?vue&type=template&id=49816542&scoped=true"
import script from "./couponHistList.vue?vue&type=script&lang=js"
export * from "./couponHistList.vue?vue&type=script&lang=js"
import style0 from "./couponHistList.vue?vue&type=style&index=0&id=49816542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49816542",
  null
  
)

export default component.exports